export const estimateSurveyV3 = {
  'estimate_survey_v3.continue': 'Pokračovat',
  'estimate_survey_v3.skip': 'Přeskočit',
  'estimate_survey_v3.send': 'Odeslat',
  'estimate_survey_v3.loading': 'Probíhá načítání formuláře...',
  'estimate_survey_v3.restore_previous.title':
    'Chcete pokračovat v rozpracovaném formuláři?',
  'estimate_survey_v3.restore_previous.subtitle':
    'Máte rozpracovaný formulář na poptávku, chcete v něm pokračovat nebo začít znovu?',
  'estimate_survey_v3.restore_previous.estate_info': 'Jedná se o nemovitost:',
  'estimate_survey_v3.restore_previous.continue': 'Pokračovat',
  'estimate_survey_v3.restore_previous.cancel': 'Začít znovu',
  'estimate_survey_v3.create_or_update_estate.error':
    'Při zpracování informací došlo k chybě, zkuste to prosím znovu později.',
  'estimate_survey_v3.lead_create.error':
    'Při odesílání došlo k chybě, zkuse to prosím znovu za pár minut.',

  // address
  'estimate_survey_v3.steps.address.title': 'Zadejte adresu nemovitosti',
  'estimate_survey_v3.steps.address.title.tooltip':
    'Zadejte jméno ulice, číslo popisné a název obce. Poloha a adresa nemovitosti mají na její hodnotu zcela zásadní vliv.',
  'estimate_survey_v3.steps.address.streetAndNumber': 'Ulice a číslo',
  'estimate_survey_v3.steps.address.streetAndNumber.placeholder':
    'např. Nádražní 6',
  'estimate_survey_v3.steps.address.municipality': 'Město',
  'estimate_survey_v3.steps.address.municipality.placeholder': 'např. Praha',
  'estimate_survey_v3.steps.address.disclaimer':
    'Jedná se o nemovitost bez adresy?',
  'estimate_survey_v3.steps.address.search_for_parcel':
    'Chcete-li odhad <b>pro pozemek</b>, pokračujte ',
  'estimate_survey_v3.steps.address.parcel_link': 'bez zadání adresy',

  // address numbers
  'estimate_survey_v3.steps.address_numbers.title':
    'Doplňte číslo popisné nebo orientační',
  'estimate_survey_v3.steps.address_numbers.numbers':
    'Číslo popisné/orientační/evidenční',
  'estimate_survey_v3.steps.address_numbers.numbers.required':
    'Zadejte prosím číslo popisné/orientační/evidenční',
  'estimate_survey_v3.steps.address_numbers.numbers.placeholder':
    'např. 45 nebo 869/1a',

  'estimate_survey_v3.steps.address_suggestion_selection.title':
    'Vyberte správnou adresu',
  'estimate_survey_v3.steps.address_suggestion_selection.subtitle':
    'Vámi zdané adrese odpovídá více výsledků. Vyberte prosím ten správný.',

  // address confirmation
  'estimate_survey_v3.steps.confirm_address.question':
    'Je tato adresa správná?',
  'estimate_survey_v3.steps.confirm_address.not_found.title':
    'Nenašli jsme žádnou adresu.',
  'estimate_survey_v3.steps.confirm_address.not_found.subtitle':
    'Zkuste to prosím znovu.',
  'estimate_survey_v3.steps.confirm_address.buttons.next': 'Ano, je správná',
  'estimate_survey_v3.steps.confirm_address.buttons.back': 'Upravit',

  // estate type
  'estimate_survey_v3.steps.estate_type.title':
    'Pro jaký typ nemovitosti hledáte odhad?',
  'estimate_survey_v3.steps.estate_type.options.house': 'Celý dům',
  'estimate_survey_v3.steps.estate_type.options.flat': 'Byt',

  // other estate type
  'estimate_survey_v3.steps.other_building_type.title':
    'O jaký typ budovy se jedná?',
  'estimate_survey_v3.steps.other_building_type.option.apartment_building':
    'Bytový dům',
  'estimate_survey_v3.steps.other_building_type.option.family_house':
    'Rodinný dům',
  'estimate_survey_v3.steps.other_building_type.option.other': 'Něco jiného',

  // appreciable unit
  'estimate_survey_v3.steps.appreciable_unit.title':
    'Je v budově byt, který chcete ocenit?',

  // unit number selection
  'estimate_survey_v3.steps.unit_number_selection.title': 'Vyberte jednotku',
  'estimate_survey_v3.steps.unit_number_selection.title.tooltip':
    'Výběrem bytové jednotky se budete moci k odhadu ceny bytu kdykoliv vrátit, aniž byste museli zadávat všechny informace znovu. Pokud číslo byt. jednotky neznáte nebo jste ho nenašli v seznamu, klikněte na tlačítko "Přeskočit".',
  'estimate_survey_v3.steps.unit_number_selection.label':
    'Stačí <b>číslo</b> jednotky:',
  'estimate_survey_v3.steps.unit_number_selection.unit_list_item':
    'č. {buildingNumber}/{unitNumber}',
  'estimate_survey_v3.steps.unit_number_selection.show_all_units':
    'Zobrazit všechny jednotky ({count})...',
  'estimate_survey_v3.steps.unit_number_selection.placeholder': 'např. 11',
  'estimate_survey_v3.steps.unit_number_selection.skip': 'Přeskočit',
  'estimate_survey_v3.steps.unit_number_selection.continue': 'Pokračovat',

  // Unit area and amenities
  'estimate_survey_v3.steps.unit_area_and_amenities.title':
    'Zadejte základní parametry bytu',
  'estimate_survey_v3.steps.unit_area_and_amenities.title.check':
    'Ověřte či opravte parametry bytu',
  'estimate_survey_v3.steps.unit_area_and_amenities.title.tooltip':
    'Do podlahové plochy bytu se započítává veškerá vnitřní plocha bytu včetně všech zastavěných ploch, jako jsou nosné stěny i příčky, sloupy, pilíře, vestavěné skříně apod. Nezapočítávají se sem vnější plochy bytu jako je balkon, terasa, zahrada nebo sklep. Tyto plochy můžete uvést po zaškrtnutí konkrétních příslušenství bytu.',

  'estimate_survey_v3.steps.unit_area_and_amenities.area.label':
    'Podlahová plocha bytu v m<sup>2</sup>',
  'estimate_survey_v3.steps.unit_area_and_amenities.area.info':
    'Nezapočítávejte balkon, zahradu ani sklep',
  'estimate_survey_v3.steps.unit_area_and_amenities.area.required':
    'Vyplňte prosím podlahovou plochu bytu v m<sup>2</sup>',
  'estimate_survey_v3.steps.unit_area_and_amenities.area.valid':
    'Zadejte prosím správnou podlahovou plochu, minimální plocha pro odhad je 10 m<sup>2</sup>',

  'estimate_survey_v3.steps.unit_area_and_amenities.amenities.title':
    'Příslušenství bytu',
  'estimate_survey_v3.steps.unit_area_and_amenities.amenities.area': 'Výměra:',
  'estimate_survey_v3.steps.unit_area_and_amenities.amenity_area.valid':
    'Minimální hodnota je&nbsp;1.',
  'estimate_survey_v3.steps.unit_area_and_amenities.warnings.amenity_area':
    'Uvedená plocha je neobvyklá a může mít velký vliv na odhad ceny.<br></br>Zkontrolujte prosím její správnost.',

  'estimate_survey_v3.steps.unit_area_and_amenities.amenity_area.type':
    'Hodnota musí být číslo.',

  'estimate_survey_v3.steps.unit_area_and_amenities.amenities.balcony':
    'Balkon',
  'estimate_survey_v3.steps.unit_area_and_amenities.amenities.balcony.max':
    'Maximální hodnota je&nbsp;100.',
  'estimate_survey_v3.steps.unit_area_and_amenities.amenities.loggia': 'Lodžie',
  'estimate_survey_v3.steps.unit_area_and_amenities.amenities.loggia.max':
    'Maximální hodnota je&nbsp;100.',
  'estimate_survey_v3.steps.unit_area_and_amenities.amenities.terrace':
    'Terasa',
  'estimate_survey_v3.steps.unit_area_and_amenities.amenities.terrace.max':
    'Maximální hodnota je&nbsp;200.',
  'estimate_survey_v3.steps.unit_area_and_amenities.amenities.cellar': 'Sklep',
  'estimate_survey_v3.steps.unit_area_and_amenities.amenities.cellar.max':
    'Maximální hodnota je&nbsp;70.',
  'estimate_survey_v3.steps.unit_area_and_amenities.amenities.garden':
    'Zahrada',
  'estimate_survey_v3.steps.unit_area_and_amenities.amenities.garden.max':
    'Maximální hodnota je&nbsp;1000.',

  // Unit disposition
  'estimate_survey_v3.steps.unit_disposition.title': 'Vyberte dispozici bytu',
  'estimate_survey_v3.steps.unit_disposition.title.check':
    'Souhlasí dispozice bytu?',
  'estimate_survey_v3.steps.unit_disposition.title.tooltip':
    'První číslo udává počet místností, druhé číslo počet samostatných kuchyní. Zkratka kk značí kuchyňský kout, který je součástí jiné místnosti. Nejmenší dispozicí je garsoniéra (studio), značená 1+kk.',
  'estimate_survey_v3.steps.unit_disposition.required':
    'Vyberte prosím dispozici bytu',
  'estimate_survey_v3.steps.unit_disposition.disposition.1+kk': '1+KK',
  'estimate_survey_v3.steps.unit_disposition.disposition.1+1': '1+1',
  'estimate_survey_v3.steps.unit_disposition.disposition.2+kk': '2+KK',
  'estimate_survey_v3.steps.unit_disposition.disposition.2+1': '2+1',
  'estimate_survey_v3.steps.unit_disposition.disposition.3+kk': '3+KK',
  'estimate_survey_v3.steps.unit_disposition.disposition.3+1': '3+1',
  'estimate_survey_v3.steps.unit_disposition.disposition.4+kk': '4+KK',
  'estimate_survey_v3.steps.unit_disposition.disposition.4+1': '4+1',
  'estimate_survey_v3.steps.unit_disposition.disposition.larger': 'Větší',

  // Unit kitchen condition
  'estimate_survey_v3.steps.unit_kitchen_condition.title':
    'Určete stav kuchyně',
  'estimate_survey_v3.steps.unit_kitchen_condition.title.check':
    'Potvrďte stav kuchyně',
  'estimate_survey_v3.steps.unit_kitchen_condition.condition.excellent':
    'Výborný',
  'estimate_survey_v3.steps.unit_kitchen_condition.condition.excellent.text':
    'Po rekonstrukci nebo do&nbsp;2&nbsp;let stáří',
  'estimate_survey_v3.steps.unit_kitchen_condition.condition.newish': 'Zánovní',
  'estimate_survey_v3.steps.unit_kitchen_condition.condition.newish.text':
    'Drobné nedostatky, stáří od&nbsp;2&nbsp;do&nbsp;10&nbsp;let',
  'estimate_survey_v3.steps.unit_kitchen_condition.condition.good': 'Dobrý',
  'estimate_survey_v3.steps.unit_kitchen_condition.condition.good.text':
    'Již má dost za sebou, stáří 10&nbsp;let a&nbsp;více',
  'estimate_survey_v3.steps.unit_kitchen_condition.condition.bad': 'Špatný',
  'estimate_survey_v3.steps.unit_kitchen_condition.condition.bad.text':
    'Chybí nebo je nutné provést rekonstrukci',

  // Unit bathroom condition
  'estimate_survey_v3.steps.unit_bathroom_condition.title':
    'Určete stav koupelny',
  'estimate_survey_v3.steps.unit_bathroom_condition.title.check':
    'Potvrďte stav koupelny',
  'estimate_survey_v3.steps.unit_bathroom_condition.condition.excellent':
    'Výborný',
  'estimate_survey_v3.steps.unit_bathroom_condition.condition.excellent.text':
    'Po rekonstrukci nebo do&nbsp;2&nbsp;let stáří',
  'estimate_survey_v3.steps.unit_bathroom_condition.condition.newish':
    'Zánovní',
  'estimate_survey_v3.steps.unit_bathroom_condition.condition.newish.text':
    'Drobné nedostatky, stáří od&nbsp;2&nbsp;do&nbsp;10&nbsp;let',
  'estimate_survey_v3.steps.unit_bathroom_condition.condition.good': 'Dobrý',
  'estimate_survey_v3.steps.unit_bathroom_condition.condition.good.text':
    'Již má dost za sebou, stáří 10&nbsp;let a&nbsp;více',
  'estimate_survey_v3.steps.unit_bathroom_condition.condition.bad': 'Špatný',
  'estimate_survey_v3.steps.unit_bathroom_condition.condition.bad.text':
    'Určená ke kompletní rekonstrukci',

  // Unit floor
  'estimate_survey_v3.steps.unit_floor.title':
    'Uveďte podlaží a přítomnost výtahu',
  'estimate_survey_v3.steps.unit_floor.title.check':
    'Ověřte podlaží a přítomnost výtahu',
  'estimate_survey_v3.steps.unit_floor.title.tooltip':
    'Podlaží, ve kterém se byt nachází, ovlivňuje výslednou cenu. Byty v nejnižších podlažích mají typicky nižší hodnotu. Obdobně na tom jsou byty ve vyšších podlažích, pokud v budově není výtah.',
  'estimate_survey_v3.steps.unit_floor.floor.label': 'Číslo podlaží bytu',
  'estimate_survey_v3.steps.unit_floor.floor.required':
    'Vyplňte prosím podlaží',
  'estimate_survey_v3.steps.unit_floor.floors.label': 'Počet podlaží v budově',
  'estimate_survey_v3.steps.unit_floor.floors.required':
    'Vyplňte prosím počet podlaží',
  'estimate_survey_v3.steps.unit_floor.floors.max':
    'Maximální hodnota je&nbsp;29.',
  'estimate_survey_v3.steps.unit_floor.floors.min':
    'Počet podlaží musí být stejný nebo větší než 1.',
  'estimate_survey_v3.steps.unit_floor.floors.larger_than_flat_floor':
    'Počet podlaží musí být stejný nebo větší než číslo podlaží bytu',
  'estimate_survey_v3.steps.unit_floor.elevator.label': 'Je v budově výtah?',
  'estimate_survey_v3.steps.unit_floor.elevator.required':
    'Uveďte prosím, zda je v budově výtah.',

  // Unit ownership
  'estimate_survey_v3.steps.unit_ownership.title': 'Vyberte formu vlastnictví',
  'estimate_survey_v3.steps.unit_ownership.title.check':
    'Souhlasí forma vlastnictví?',
  'estimate_survey_v3.steps.unit_ownership.title.tooltip':
    'Byty v družstevním vlastnictví se obvykle prodávají za nižší cenu než byty ve vlastnictví soukromém. Obě varianty vlastnictví mají své klady i zápory.',

  'estimate_survey_v3.steps.unit_ownership.ownership.private': 'Osobní',
  'estimate_survey_v3.steps.unit_ownership.ownership.collective': 'Družstevní',
  'estimate_survey_v3.steps.unit_ownership.ownership.national_or_municipal':
    'Státní/obecní',
  'estimate_survey_v3.steps.unit_ownership.ownership.mixed': 'Smíšené',
  'estimate_survey_v3.steps.unit_ownership.ownership.other': 'Jiné',

  // Unit parking
  'estimate_survey_v3.steps.unit_parking.title':
    'Vlastníte k bytu parkovací stání?',
  'estimate_survey_v3.steps.unit_parking.title.tooltip':
    'Vlastnictví parkovacího stání významně zvyšuje hodnotu bytu. Pokud k bytu vlastnicky náleží venkovní nebo garážové parkovací stání, prosím, uveďte jej včetně jejich počtu.',
  'estimate_survey_v3.steps.unit_parking.tip':
    'Uveďte jen v případě, že jsou ve vašem osobním&nbsp;vlastnictví.',
  'estimate_survey_v3.steps.unit_parking.parking_space': 'Venkovní park. stání',
  'estimate_survey_v3.steps.unit_parking.garage': 'Garáž',
  'estimate_survey_v3.steps.unit_parking.count': 'Počet stání:',
  'estimate_survey_v3.steps.unit_parking.warnings.count':
    'Uvedený počet stání je neobvyklý a má velký vliv na konečný odhad ceny.<br></br>Zkontrolujte prosím správnost údaje.',

  // Unit construction
  'estimate_survey_v3.steps.unit_construction.title': 'Zadejte typ stavby',
  'estimate_survey_v3.steps.unit_construction.title.check':
    'Souhlasí typ stavby?',
  'estimate_survey_v3.steps.unit_construction.title.tooltiop':
    'Cihlové domy mívají obvykle do 5 pater. Vyšší domy bývají typicky panelové nebo monolitické (především novostavby).',
  'estimate_survey_v3.steps.unit_construction.construction.brick_stone':
    'Cihla',
  'estimate_survey_v3.steps.unit_construction.construction.panel': 'Panel',
  'estimate_survey_v3.steps.unit_construction.construction.wood': 'Dřevo',
  'estimate_survey_v3.steps.unit_construction.construction.other': 'Jiný',
  'estimate_survey_v3.steps.unit_construction.construction.monolith': 'Monolit',

  // Unit finished at type
  'estimate_survey_v3.steps.unit_finished_at_type.title':
    'Znáte přesný rok výstavby?',

  // Unit finished at exact
  'estimate_survey_v3.steps.unit_finished_at_exact.title':
    'Zadejte rok výstavby',
  'estimate_survey_v3.steps.unit_finished_at_exact.finished_at.label':
    'Rok výstavby',
  'estimate_survey_v3.steps.unit_finished_at_exact.finished_at.min_max':
    'Rok výstavby musí být větší než 1900 a nižší než letošní rok',

  // Unit finished at range
  'estimate_survey_v3.steps.unit_finished_at_range.title':
    'Zadejte rok výstavby',

  // house areas step
  'estimate_survey_v3.step.house_areas.title':
    'Doplňte údaje o plochách nemovitosti',
  'estimate_survey_v3.step.house_areas.floor_area': 'Podlahová plocha',
  'estimate_survey_v3.step.house_areas.floor_area.error.min':
    'Zadejte, prosím, výměru plochy alespoň 15 m<sup>2</sup>',
  'estimate_survey_v3.step.house_areas.error.required':
    'Vyplňte prosím toto pole',
  'estimate_survey_v3.step.house_areas.floor_area.error.max':
    'Maximální výměra je 1 200 m<sup>2</sup>. Prosím, upravte údaj.',
  'estimate_survey_v3.step.house_areas.land_area.error.positive':
    'Hodnota nesmí být menší než 0.',
  'estimate_survey_v3.step.house_areas.land_area': 'Plocha pozemku',
  'estimate_survey_v3.step.house_areas.floor_area.info':
    'Součet vnitřních ploch hlavní budovy <b>včetně</b> sklepu, půdy a neobývaných prostor. ',
  'estimate_survey_v3.step.house_areas.floor_area.more_info': 'Více&nbsp;info',
  'estimate_survey_v3.step.house_areas.land_area.info':
    'Zadejte celkovou plochu pozemků včetně zastavěných ploch.',

  // estate condition step
  'estimate_survey_v3.step.house_condition.title': 'V jakém stavu je stavba',
  'estimate_survey_v3.step.house_condition.condition.excellent': 'Výborný',
  'estimate_survey_v3.step.house_condition.condition.excellent.text':
    'Po rekonstrukci nebo do 2&nbsp;let stáří',
  'estimate_survey_v3.step.house_condition.condition.newish': 'Zánovní',
  'estimate_survey_v3.step.house_condition.condition.newish.text':
    'Drobné nedostatky, stáří od&nbsp;2&nbsp;do&nbsp;10&nbsp;let',
  'estimate_survey_v3.step.house_condition.condition.good': 'Dobrý',
  'estimate_survey_v3.step.house_condition.condition.good.text':
    'Jsou nutné opravy, stáří 10&nbsp;let a&nbsp;více',
  'estimate_survey_v3.step.house_condition.condition.bad': 'Špatný',
  'estimate_survey_v3.step.house_condition.condition.bad.text':
    'Objekt ke kompletní rekonstrukci či demolici',

  // House kitchen condition
  'estimate_survey_v3.steps.house_kitchen_condition.title':
    'Určete stav kuchyně',
  'estimate_survey_v3.steps.house_kitchen_condition.title.check':
    'Potvrďte stav kuchyně',
  'estimate_survey_v3.steps.house_kitchen_condition.condition.excellent':
    'Výborný',
  'estimate_survey_v3.steps.house_kitchen_condition.condition.excellent.text':
    'Po rekonstrukci nebo do&nbsp;2&nbsp;let stáří',
  'estimate_survey_v3.steps.house_kitchen_condition.condition.newish':
    'Zánovní',
  'estimate_survey_v3.steps.house_kitchen_condition.condition.newish.text':
    'Drobné nedostatky, stáří od&nbsp;2&nbsp;do&nbsp;10&nbsp;let',
  'estimate_survey_v3.steps.house_kitchen_condition.condition.good': 'Dobrý',
  'estimate_survey_v3.steps.house_kitchen_condition.condition.good.text':
    'Již má dost za sebou, stáří 10&nbsp;let a&nbsp;více',
  'estimate_survey_v3.steps.house_kitchen_condition.condition.bad': 'Špatný',
  'estimate_survey_v3.steps.house_kitchen_condition.condition.bad.text':
    'Chybí nebo je nutné provést rekonstrukci',

  // House bathroom condition
  'estimate_survey_v3.steps.house_bathroom_condition.title':
    'Určete stav koupelny',
  'estimate_survey_v3.steps.house_bathroom_condition.title.check':
    'Potvrďte stav koupelny',
  'estimate_survey_v3.steps.house_bathroom_condition.condition.excellent':
    'Výborný',
  'estimate_survey_v3.steps.house_bathroom_condition.condition.excellent.text':
    'Po rekonstrukci nebo do&nbsp;2&nbsp;let stáří',
  'estimate_survey_v3.steps.house_bathroom_condition.condition.newish':
    'Zánovní',
  'estimate_survey_v3.steps.house_bathroom_condition.condition.newish.text':
    'Drobné nedostatky, stáří od&nbsp;2&nbsp;do&nbsp;10&nbsp;let',
  'estimate_survey_v3.steps.house_bathroom_condition.condition.good': 'Dobrý',
  'estimate_survey_v3.steps.house_bathroom_condition.condition.good.text':
    'Již má dost za sebou, stáří 10&nbsp;let a&nbsp;více',
  'estimate_survey_v3.steps.house_bathroom_condition.condition.bad': 'Špatný',
  'estimate_survey_v3.steps.house_bathroom_condition.condition.bad.text':
    'Chybí nebo je nutné provést rekonstrukci',

  // House exact finished at
  'estimate_survey_v3.step.building_exact_finished_at.title':
    'Znáte přesný rok výstavby?',

  // House finished at
  'estimate_survey_v3.step.building_finished_at.title': 'Zadejte rok výstavby',
  'estimate_survey_v3.step.building_finished_at.label': 'Rok výstavby',
  'estimate_survey_v3.step.building_finished_at.verify.title':
    'Potvrďte rok výstavby',
  'estimate_survey_v3.step.building_finished_at.required':
    'Zadejte prosím rok výstavby',
  'estimate_survey_v3.step.building_finished_at.min_max':
    'Rok výstavby musí být větší než 1900 a nižší než letošní rok',

  // House finished at interval
  'estimate_survey_v3.step.building_finished_at_interval.title':
    'Vyberte orientační rok výstavby',
  'estimate_survey_v3.step.building_finished_at_interval.verify.title':
    'Potvrďte orientační rok výstavby',

  // House floors count
  'estimate_survey_v3.steps.house_floors_count.options.1': '1 podlaží',
  'estimate_survey_v3.steps.house_floors_count.options.2': '2 podlaží',
  'estimate_survey_v3.steps.house_floors_count.options.3': '3 podlaží',
  'estimate_survey_v3.steps.house_floors_count.options.4': '4 podlaží',
  'estimate_survey_v3.steps.house_floors_count.options.5': 'Více než 4 podlaží',
  'estimate_survey_v3.steps.house_floors_count.title': 'Kolik podlaží dům má?',
  'estimate_survey_v3.steps.house_floors_count.tooltip':
    'Víte, že podlaží není to samé jako patro? U podlaží rozlišujeme, zda se jedná o nadzemní podlaží (NP) nebo podzemní podlaží (PP). Uveďte prosím celkový počet podlaží (součet PP a NP).<br></br><b>Příklad:</b><br></br>Podsklepení domu = 1.PP<br></br>Přízemí = 1.NP<br></br>1.patro = 2.NP<br></br>Tzn. celkem 3 podlaží',

  'estimate_survey_v3.steps.house_floors_count_confirmation.title':
    'Potvrďte počet podlaží',
  'estimate_survey_v3.steps.house_floors_count_confirmation.subtitle':
    'Pokud údaj nesedí, opravte jej prosím.',
  'estimate_survey_v3.steps.house_floors_count_confirmation.label':
    'Počet podlaží',
  'estimate_survey_v3.steps.house_floors_count_confirmation.min':
    'Počet podlaží nesmí být menší než 1.',
  'estimate_survey_v3.steps.house_floors_count_confirmation.required':
    'Počet podlaží musí být číslo.',

  'estimate_survey_v3.steps.house_floors_count_input.title':
    'Upřesněte počet podlaží',
  'estimate_survey_v3.steps.house_floors_count_input.label': 'Počet podlaží',
  'estimate_survey_v3.steps.house_floors_count_input.tooltip':
    'Víte, že podlaží není to samé jako patro? U podlaží rozlišujeme, zda se jedná o nadzemní podlaží (NP) nebo podzemní podlaží (PP). Uveďte prosím celkový počet podlaží (součet PP a NP).<br></br><b>Příklad:</b><br></br>Podsklepení domu = 1.PP<br></br>Přízemí = 1.NP<br></br>1.patro = 2.NP<br></br>Tzn. celkem 3 podlaží',
  'estimate_survey_v3.steps.house_floors_count_input.min':
    'Počet podlaží nesmí být menší než 5.',
  'estimate_survey_v3.steps.house_floors_count_input.required':
    'Počet podlaží musí být číslo.',

  // house separation
  'estimate_survey_v3.steps.house_separation.title': 'Jaká je poloha domu?',
  'estimate_survey_v3.steps.house_separation.options.stand_alone':
    'Samostatně stojící',
  'estimate_survey_v3.steps.house_separation.options.stand_alone.info':
    'Dům stojí na pozemku samostatně',
  'estimate_survey_v3.steps.house_separation.options.terraced':
    'Řadový / v bloku',
  'estimate_survey_v3.steps.house_separation.options.terraced.info':
    'Dům alespoň z jedné strany navazuje na další domy v ulici',

  // house nearby traffic routes
  'estimate_survey_v3.steps.nearby_traffic_route.title':
    'Je v blízkosti domu rušná dopravní tepna?',

  'estimate_survey_v3.steps.nearby_traffic_routes.title':
    'Jaké rušné dopravní tepny se v okolí nachází?',
  'estimate_survey_v3.steps.nearby_traffic_routes.options.main_road':
    'Silnice / Dálnice',
  'estimate_survey_v3.steps.nearby_traffic_routes.options.railway': 'Železnice',
  'estimate_survey_v3.steps.nearby_traffic_routes.options.airport': 'Letiště',

  // house amenities
  'estimate_survey_v3.steps.house_accessories.title':
    'Doplňte, co dalšího k domu patří‍',
  'estimate_survey_v3.steps.house_accessories.tooltip':
    'V tomto kroku vyplňte všechno příslušenství, které může hodnotu domu zvýšit.',
  'estimate_survey_v3.steps.house_accessories.options.parking':
    'Garáž / Parkovací stání',
  'estimate_survey_v3.steps.house_accessories.options.pool': 'Bazén',
  'estimate_survey_v3.steps.house_accessories.options.fireplace': 'Krb',
  'estimate_survey_v3.steps.house_accessories.options.sauna': 'Sauna',
  'estimate_survey_v3.steps.house_accessories.options.pergola': 'Pergola',
  'estimate_survey_v3.steps.house_accessories.options.solar_panels':
    'Solární panely',
  'estimate_survey_v3.steps.house_accessories.options.heat_pump':
    'Tepelné čerpadlo',

  // house parking step
  'estimate_survey_v3.steps.house_parking.title':
    'Jaká forma parkování k domu náleží?',
  'estimate_survey_v3.steps.house_parking.warning':
    'Uvedený počet stání je neobvyklý a může mít vliv na konečný odhad ceny. Zkontrolujte prosím správnost údaje.',
  'estimate_survey_v3.steps.house_parking.min': 'Minimum je 1.',
  'estimate_survey_v3.steps.house_parking.required': 'Zadejte počet.',
  'estimate_survey_v3.steps.house_parking.subtitle':
    'Vyberte prosím typ a <b>upřesněte počet stání.</b>',
  'estimate_survey_v3.steps.house_parking.garage': 'Garáž',
  'estimate_survey_v3.steps.house_parking.covered_parking_space':
    'Kryté parkovací místo',
  'estimate_survey_v3.steps.house_parking.uncovered_parking_space':
    'Nekryté parkovací místo',

  // house pool type
  'estimate_survey_v3.steps.pool_type.title': 'Upřesněte typ bazénu',
  'estimate_survey_v3.steps.pool_type.sunken': 'Zapuštěný',
  'estimate_survey_v3.steps.pool_type.semi_sunken': 'Polozapuštěný',
  'estimate_survey_v3.steps.pool_type.above_ground': 'Nadzemní',

  // house fireplace type
  'estimate_survey_v3.steps.fireplace_type.title': 'Upřesněte typ krbu',
  'estimate_survey_v3.steps.fireplace_type.options.burner_stove':
    'Krbová kamna',
  'estimate_survey_v3.steps.fireplace_type.options.built_in': 'Zabudovaný krb',
  'estimate_survey_v3.steps.fireplace_type.options.tiled':
    'Kachlová kamna se sporákem nebo pecí',

  // house sauna type
  'estimate_survey_v3.steps.sauna_type.title': 'Upřesněte typ sauny',
  'estimate_survey_v3.steps.sauna_type.options.basic': 'Základní',
  'estimate_survey_v3.steps.sauna_type.options.luxurious': 'Luxusní',

  // house pergola type
  'estimate_survey_v3.steps.pergola_type.title': 'Upřesněte typ pergoly',
  'estimate_survey_v3.steps.pergola_type.options.classic': 'Klasická',
  'estimate_survey_v3.steps.pergola_type.options.glassed': 'Zasklená',
  'estimate_survey_v3.steps.pergola_type.options.bio_climatic': 'Bioklimatická',

  // house solar panels purpose
  'estimate_survey_v3.steps.solar_panel_purpose.title':
    'Jaký je způsob využití solárních panelů?',
  'estimate_survey_v3.steps.solar_panel_purpose.options.electricity_generation':
    'Výroba elektřiny',
  'estimate_survey_v3.steps.solar_panel_purpose.options.water_heating':
    'Ohřev vody',
  'estimate_survey_v3.steps.solar_panel_purpose.options.electricity_generation_water_heating':
    'Obojí',

  // house solar panels area
  'estimate_survey_v3.steps.solar_panel_area.title':
    'Doplňte plochu solárních panelů',
  'estimate_survey_v3.steps.solar_panel_area.label': 'Plocha panelů',
  'estimate_survey_v3.steps.solar_panel_area.required':
    'Zadejte prosím plochu panelů',
  'estimate_survey_v3.steps.solar_panel_area.positive':
    'Zadejte prosím kladnou plochu panelů',

  // house heat pump type
  'estimate_survey_v3.steps.heat_pump_type.title':
    'Upřesněte typ tepelného čerpedla',
  'estimate_survey_v3.steps.heat_pump_type.options.air_air': 'Vzduch-vzduch',
  'estimate_survey_v3.steps.heat_pump_type.options.air_water': 'Vzduch-voda',
  'estimate_survey_v3.steps.heat_pump_type.options.water_water': 'Voda-voda',
  'estimate_survey_v3.steps.heat_pump_type.options.ground_water': 'Země-voda',

  // estimate reason
  'estimate_survey_v3.steps.estimate_reason.title': 'Proč si odhad počítáte?',
  'estimate_survey_v3.steps.estimate_reason.subtitle':
    'Odpověď nám pomůže ke zkvalitnění služby a nemá vliv na výsledek.',
  'estimate_survey_v3.steps.estimate_reason.option.consider_selling':
    'Uvažuji o prodeji',

  'estimate_survey_v3.steps.estimate_reason.option.owner': `Vlastním {estateType, select,
      flat {tento byt}
      house {tento dům}
      land {tento pozemek}
      other {tuto nemovitost}
     }`,

  'estimate_survey_v3.steps.estimate_reason.option.other': 'Jiný důvod',

  // requalification step
  'estimate_survey_v3.steps.requalification.title':
    'Chcete zjistit, kolik můžete získat prodejem nemovitosti?',
  'estimate_survey_v3.steps.requalification.subtitle':
    'Ve vaší lokalitě evidujeme zájemce o koupi nemovitosti podobné té vaší.',
  'estimate_survey_v3.steps.requalification.option.yes':
    'Ano, přemýšlím o prodeji',
  'estimate_survey_v3.steps.requalification.option.no':
    'Ne, nemám zájem prodávat',

  // Sell horizon step
  'estimate_survey_v3.steps.sell_horizon.title': `Jak rychle chcete {estateType, select,
      flat {byt}
      house {dům}
      land {pozemek}
      other {nemovitost}
     } prodat?`,
  'estimate_survey_v3.steps.sell_horizon.required':
    'Vyplňte prosím časový horizont, ve kterém chcete prodat',
  'estimate_survey_v3.steps.sell_horizon.option.asap': 'Co nejdříve',
  'estimate_survey_v3.steps.sell_horizon.option.less_than_6_months':
    'Do 6 měsíců',
  'estimate_survey_v3.steps.sell_horizon.option.7_months_and_later': 'Později',

  // Is owner step
  'estimate_survey_v3.steps.is_owner.title': 'Jste majitel?',
  'estimate_survey_v3.steps.is_owner.required':
    'Vyplňte prosím zda jste majitelem nemovitosti',
  'estimate_survey_v3.steps.is_owner.option.yes': 'Ano',
  'estimate_survey_v3.steps.is_owner.option.no': 'Ne',
  'estimate_survey_v3.steps.is_owner.option.represent': 'Zastupuji majitele',

  // Owners approval step
  'estimate_survey_v3.steps.owners_approval.title':
    'Souhlasí všichni majitelé s prodejem?',
  'estimate_survey_v3.steps.owners_approval.required':
    'Vyplňte prosím zda všichni majitelé souhlasí s prodejem',

  // wanna sell with broker step
  'estimate_survey_v3.steps.wants_broker.title':
    'Přemýšlíte o prodeji s realitní kanceláří?',
  'estimate_survey_v3.steps.wants_broker.required':
    'Vyplňte prosím zda přemýšlíte o prodeji s realitní kanceláří',

  // Already selling step
  'estimate_survey_v3.steps.already_selling.title':
    'Nabízí se již nemovitost k prodeji?',
  'estimate_survey_v3.steps.already_selling.required':
    'Vyplňte prosím zda se nemovitost již nabízí k prodeji',
  'estimate_survey_v3.steps.already_selling.yes_with_broker_exclusive':
    'Ano, mám exkluzivní spolupráci s makléřem',
  'estimate_survey_v3.steps.already_selling.yes_with_broker_not_exclusive':
    'Ano, mám neexkluzivní spolupráci s makléřem',
  'estimate_survey_v3.steps.already_selling.yes_i_advertise_it':
    'Ano, inzeruji sám',
  'estimate_survey_v3.steps.already_selling.no': 'Ne',

  // Price expectation step
  'estimate_survey_v3.steps.price_expectation.title':
    'Jakou máte představu o ceně?',
  'estimate_survey_v3.steps.price_expectation.required':
    'Vyplňte prosím vaši cenovou představu.',
  'estimate_survey_v3.steps.price_expectation.positive':
    'Cenová představa nemůže být záporná.',
  'estimate_survey_v3.steps.price_expectation.label': 'Představa o ceně',

  // email step
  'estimate_survey_v3.steps.contact_split.email.title': `Váš orientační odhad ceny {estateType, select,
      flat {bytu}
      house {domu}
      land {pozemku}
      other {nemovitosti}
     } je připravený`,
  'estimate_survey_v3.steps.contact_split.email.subtitle':
    'Stačí zadat váš e-mail, na který vám odhad ceny pošleme.',
  'estimate_survey_v3.steps.contact_split.email.label':
    'E-mail pro zaslání odhadu',
  'estimate_survey_v3.steps.contact_split.email.text':
    'Vaše údaje jsou u nás v bezpečí. Odesláním souhlasíte se <gdpr>zpracováním osobních údajů</gdpr>.',
  'estimate_survey_v3.steps.contact_split.email.required':
    'Vyplňte prosím platný e-mail',
  'estimate_survey_v3.steps.contact_split.email.cta.next':
    'Získat odhad ZDARMA',
  'estimate_survey_v3.steps.contact_split.email.cta.back': 'Zpět',

  // email step
  'estimate_survey_v3.steps.email.title': `Váš orientační odhad ceny {estateType, select,
      flat {bytu}
      house {domu}
      land {pozemku}
      other {nemovitosti}
     } je připravený k odeslání`,
  'estimate_survey_v3.steps.email.label': 'E-mail pro zaslání odhadu',
  'estimate_survey_v3.steps.email.text':
    'Vaše údaje jsou u nás v bezpečí. Odesláním souhlasíte se <gdpr>zpracováním osobních údajů</gdpr>.',
  'estimate_survey_v3.steps.email.required': 'Vyplňte prosím platný e-mail',
  'estimate_survey_v3.steps.email.cta.next': 'Pokračovat k odeslání',
  'estimate_survey_v3.steps.email.cta.back': 'Zpět',
  'estimate_survey_v3.steps.email.footer': 'Nechci odhad odeslat na e-mail',

  // Contact step
  'estimate_survey_v3.steps.contact.title.exact_estimate':
    'Pro získání přesného odhadu vyplňte kontaktní údaje',
  'estimate_survey_v3.steps.contact.title':
    'Pro získání odhadu vyplňte kontaktní údaje',
  'estimate_survey_v3.steps.contact.subtitle.exact_estimate':
    'Zjistěte nezávazně a zdarma přesný odhad ceny nemovitosti a jak nejlépe prodat.',
  'estimate_survey_v3.steps.contact.subtitle':
    'Zjistěte nezávazně a zdarma odhad ceny nemovitosti a jak nejlépe prodat.',
  'estimate_survey_v3.steps.contact.cta.next.exact_estimate':
    'Získat přesný odhad ZDARMA',
  'estimate_survey_v3.steps.contact.cta.next': 'Získat odhad ZDARMA',

  'estimate_survey_v3.steps.contact.fullname': 'Jméno a příjmení',
  'estimate_survey_v3.steps.contact.fullname.required':
    'Vyplňte prosím vaše celé jméno.',
  'estimate_survey_v3.steps.contact.email': 'E-mail',
  'estimate_survey_v3.steps.contact.email.required':
    'Vyplňte prosím váš e-mail',
  'estimate_survey_v3.steps.contact.phone': 'Telefon',
  'estimate_survey_v3.steps.contact.phone.required':
    'Vyplňte prosím váš telefon',
  'estimate_survey_v3.steps.contact.phone.valid':
    'Vyplňte prosím platný telefon (např. ve tvaru 777888999, nebo +420 777 888 999)',
  'estimate_survey_v3.steps.contact.text':
    'Odesláním formuláře souhlasím s <terms>obchodními podmínkami</terms> a se <gdpr>zpracováním osobních údajů</gdpr>.',

  // Subscribe contact step
  'estimate_survey_v3.steps.subscribe.contact.title.exact_estimate':
    'Pro získání přesného odhadu vyplňte kontaktní údaje',
  'estimate_survey_v3.steps.subscribe.contact.subtitle.exact_estimate':
    'Zjistěte nezávazně a zdarma přesný odhad ceny nemovitosti a jak nejlépe prodat.',
  'estimate_survey_v3.steps.subscribe.contact.cta.next.exact_estimate':
    'Získat přesný odhad ZDARMA',

  'estimate_survey_v3.steps.subscribe.contact.fullname': 'Jméno a příjmení',
  'estimate_survey_v3.steps.subscribe.contact.fullname.required':
    'Vyplňte prosím vaše celé jméno.',

  'estimate_survey_v3.steps.subscribe.contact.phone': 'Telefon',
  'estimate_survey_v3.steps.subscribe.contact.phone.required':
    'Vyplňte prosím váš telefon',
  'estimate_survey_v3.steps.subscribe.contact.phone.valid':
    'Vyplňte prosím platný telefon (např. ve tvaru 777888999, nebo +420 777 888 999)',
  'estimate_survey_v3.steps.subscribe.contact.text':
    'Odesláním formuláře souhlasím s <terms>obchodními podmínkami</terms> a se <gdpr>zpracováním osobních údajů</gdpr>.',

  'estimate_survey_v3.steps.subscribe.contact.change_email':
    'upravit zadanou emailovou adresu',

  // SMS verification
  'estimate_survey_v3.steps.sms_verification.title':
    'Ověření telefonního čísla',
  'estimate_survey_v3.steps.sms_verification.subtitle':
    'Na tel. číslo <b>{phoneNumber}</b> jsme zaslali 4-místný SMS kód. Opište prosím kód z SMS pro ověření telefonu.',
  'estimate_survey_v3.steps.sms_verification.code': 'Kód z SMS',
  'estimate_survey_v3.steps.sms_verification.code.required':
    'Kód z SMS musí být vyplněný',
  'estimate_survey_v3.steps.sms_verification.code.invalid':
    'Kód z SMS musí být čtyřmístné číslo.',
  'estimate_survey_v3.steps.sms_verification.code.placeholder':
    'Zadejte kontrolní kód',
  'estimate_survey_v3.steps.sms_verification.submit': 'Ověřit tel. číslo',
  'estimate_survey_v3.steps.sms_verification.edit': 'Upravit tel. číslo',
  'estimate_survey_v3.steps.sms_verification.no_code_received':
    'Nedostali jste SMS kód?',
  'estimate_survey_v3.steps.sms_verification.request_new_code':
    'Poslat nový kód',
  'estimate_survey_v3.steps.sms_verification.new_code_requested':
    'Kód byl úspěšně odeslán. Doručení může pár minut trvat.',
  'estimate_survey_v3.steps.sms_verification.error.request_failed':
    'Došlo k chybě na naší straně. Zkuste to prosím znovu později.',
  'estimate_survey_v3.steps.sms_verification.error.verification_failed':
    'Zadaný kód je nesprávný.',

  // Parcel Address
  'estimate_survey_v3.steps.parcel_address.title': 'Kde se pozemek nachází?',
  'estimate_survey_v3.steps.parcel_address.municipality': 'Zadejte město',
  'estimate_survey_v3.steps.parcel_address.municipality.placeholder':
    'např. Praha',

  // Parcel Registry
  'estimate_survey_v3.steps.parcel_registry.title':
    'Doplňte katastrální území a parcelní číslo‍',
  'estimate_survey_v3.steps.parcel_registry.cadastral_area':
    'Katastrální území',
  'estimate_survey_v3.steps.parcel_registry.parcel_number': 'Parcelní číslo',

  // Parcel Purpose
  'estimate_survey_v3.steps.parcel_purpose.title': 'Vyberte typ pozemku',
  'estimate_survey_v3.steps.parcel_purpose.title.tooltip':
    'Mezi jiné pozemky řadíme např. lesní nebo vodní plochu, trať, pozemek se zříceninou a podobně.',
  'estimate_survey_v3.steps.parcel_purpose.residential': 'Obytný',
  'estimate_survey_v3.steps.parcel_purpose.recreational': 'Rekreační',
  'estimate_survey_v3.steps.parcel_purpose.agricultural': 'Zemědělský',
  'estimate_survey_v3.steps.parcel_purpose.other': 'Jiný',

  // Parcel Area
  'estimate_survey_v3.steps.parcel_area.title': 'Zadejte výměru pozemku',
  'estimate_survey_v3.steps.parcel_area.label':
    'Velikost pozemku v m<sup>2</sup>',
  'estimate_survey_v3.steps.parcel_area.required':
    'Vyplňte prosím výměru pozemku',
  'estimate_survey_v3.steps.parcel_area.positive':
    'Výměra musí být kladné číslo',
};
